/**
 * Lista "Criados agora" de `flashcard.pen#mETDb`, sob a pré-visualização.
 * O pai é dono de `itens`. Recarregar a página zera a lista porque ela não
 * é lida de lugar nenhum — nem da API, nem de localStorage.
 */
import { Check, Pencil } from 'lucide-react';
import type { CartaoCriadoAgora } from './metadadosCartao';

export interface CriadosAgoraProps {
  itens: readonly CartaoCriadoAgora[];
  onAbrir: (item: CartaoCriadoAgora) => void;
}

export default function CriadosAgora({ itens, onAbrir }: CriadosAgoraProps) {
  return (
    <section
      data-criados-agora=""
      aria-labelledby="criados-agora-titulo"
      className="rounded-card border border-edge bg-surface p-3"
    >
      <h2
        id="criados-agora-titulo"
        className="px-1 text-xs font-semibold uppercase tracking-wider text-ink-muted"
      >
        Criados agora · {itens.length}
      </h2>
      {itens.length === 0 ? (
        <p className="m-0 mt-3 px-1 text-sm text-ink-muted">Nenhum cartão criado nesta sessão.</p>
      ) : (
        <ul className="m-0 mt-2 list-none p-0">
          {itens.map((item) => (
            <li key={item.id} data-criado-id={item.id}>
              <button
                type="button"
                onClick={() => onAbrir(item)}
                aria-label={`Editar ${item.rotulo}`}
                className="flex w-full items-center gap-2.5 rounded-input px-1 py-1.5 text-left hover:bg-surface-hover"
              >
                <span
                  className="inline-flex h-[22px] w-[22px] shrink-0 items-center justify-center rounded-full bg-ok/[0.12] text-ok-ink"
                  aria-hidden="true"
                >
                  <Check size={12} />
                </span>
                <span className="min-w-0 flex-1 truncate text-sm text-ink-secondary" title={item.rotulo}>
                  {item.rotulo}
                  {item.reverso ? <span className="text-ink-muted"> · Reverso</span> : null}
                </span>
                <Pencil size={13} className="shrink-0 text-ink-muted" aria-hidden="true" />
              </button>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
